import { render, staticRenderFns } from "./DdImageInfo.vue?vue&type=template&id=51f80502&scoped=true&"
import script from "./DdImageInfo.vue?vue&type=script&lang=js&"
export * from "./DdImageInfo.vue?vue&type=script&lang=js&"
import style0 from "./DdImageInfo.vue?vue&type=style&index=0&id=51f80502&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f80502",
  null
  
)

export default component.exports